import axios from "axios";

const CustomAxios = axios.create({
  // baseURL: "https://staging-api.elitebodyx.com/v1/",
  // baseURL:"https://body-x.onrender.com/v1/"
  baseURL : "https://production-api.elitebodyx.com/v1/"
});

CustomAxios.interceptors.request.use(
  (config) => {
    if (config.data instanceof FormData) {
      config.headers["Content-Type"] = "multipart/form-data";
    } else {
      config.headers["Content-Type"] = "application/json";
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

CustomAxios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.error("Error in API call:", error);
    return Promise.reject(error);
  }
);

export default CustomAxios;
